<template>
    <Card>
        <ProductsTable :integration="integration" />
    </Card>
</template>
<script>
import Card from "../../../../../../components/new/CardComponent.vue";
import ProductsTable from "./ProductsTable.vue";

export default {
    name: "AllProductsPage",
    components: {
        Card,
        ProductsTable
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    }
}
</script>
